import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker } from "@material-ui/pickers";
import DocumentType from "../DocumentType";
import { connect } from "react-redux";
import CoreFilter from "./CoreFilter";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Badge, Radio, RadioGroup } from "@material-ui/core";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import IconButton from "@material-ui/core/IconButton";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import DocumentCategories from "../document/DocumentCategories";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { taxServiceClient } from "../../AxiosClient";

const styles = (theme) => ({
  container: {},
  gridContainer: {
    flexGrow: 1,
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  moreMarginFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  userPickerFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  userPickerWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterKnowledgeItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formControl: {
        marginTop: 5,
        marginLeft: 2,
        marginRight: 2,
        width: this.props.isMobile ? "100%" : "75%",
      },
      documentTypes: [],
      defaultFilters: [
        "taxonomy",
        "sort",
        "authoredByMe",
        "revisedByMe",
        "awaitingReview",
        "awaitingApproval",
        "awaitingPublish",
        "documentTypes",
        "showWithdrawn",
      ],
      opened: false,
      createdBy: null,
      modifiedBy: null,
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,
    };
  }
  componentDidMount() {
    if (this.props.filter.createdBy && this.props.filter.createdBy.length > 0) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
    if (
      this.props.filter.modifiedBy &&
      this.props.filter.modifiedBy.length > 0
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.modifiedBy })
        .then((res) => {
          this.setState({ modifiedBy: res.data });
        });
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if (
      !areObjectsEqual(this.props.filter.createdBy, _prevProps.filter.createdBy)
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
    if (
      !areObjectsEqual(
        this.props.filter.modifiedBy,
        _prevProps.filter.modifiedBy
      )
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.modifiedBy })
        .then((res) => {
          this.setState({ modifiedBy: res.data });
        });
    }
  }
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.sort = this.props.asPopper === true && (
      <div className={classes.sortByContainer}>
        <Typography className={classes.sortByLabel}>Sort by...</Typography>
        <FormControl className={classes.sortBy}>
          <Select
            value={this.props.filter.sort}
            onChange={this.props.handleSortChange}
            inputProps={{
              name: "sort",
              id: "sort",
            }}
          >
            <MenuItem value="none">
              <Trans i18nKey="filter_ki_sort_none" />
            </MenuItem>
            <MenuItem value="title">
              <Trans i18nKey="filter_ki_sort_title" />
            </MenuItem>
            <MenuItem value="modifiedDate">
              <Trans i18nKey="filter_ki_sort_modified_date" />
            </MenuItem>
            <MenuItem value="createdDate">
              <Trans i18nKey="filter_ki_sort_created_date" />
            </MenuItem>
            <MenuItem value="publishedDate">
              <Trans i18nKey="filter_ki_sort_published_date" />
            </MenuItem>
            <MenuItem value="withdrawnDate">
              <Trans i18nKey="filter_ki_sort_withdrawn_date" />
            </MenuItem>
          </Select>
        </FormControl>
        <Button onClick={this.props.toggleSortDirection}>
          {this.props.filter.sortDirection === "ASC" ? (
            <>
              <ArrowUpwardIcon />
              <Trans i18nKey="global_ascending" />
            </>
          ) : (
            <>
              <ArrowDownwardIcon />
              <Trans i18nKey="global_descending" />
            </>
          )}
        </Button>
      </div>
    );
    filterObj.taxonomy = (
      <FormControl className={classes.moreMarginFormControl}>
        {this.props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TaxonomySelector
          limitWithTeam
          multiSelect={true}
          allowedSelections={["taxonomy", "topic"]}
          filter={this.props.getTaxonomy(
            this.props.filter.taxonomy,
            this.props.taxonomyNodeLookup
          )}
          onNodeSelected={this.props.setTaxonomy}
        />
      </FormControl>
    );
    filterObj.createdStart = (
      <FormControl style={this.state.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdEnd
              ? moment(this.props.filter.createdEnd)
              : null
          }
          onChange={this.props.handleDateChange("createdEnd")}
        />
      </FormControl>
    );
    filterObj.createdEnd = (
      <FormControl style={this.state.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdStart
              ? moment(this.props.filter.createdStart)
              : null
          }
          onChange={this.props.handleDateChange("createdStart")}
        />
      </FormControl>
    );
    filterObj.modifiedEnd = (
      <FormControl style={this.state.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_before")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedEnd
              ? moment(this.props.filter.modifiedEnd)
              : null
          }
          onChange={this.props.handleDateChange("modifiedEnd")}
        />
      </FormControl>
    );
    filterObj.modifiedStart = (
      <FormControl style={this.state.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_last_modified_after")}
          clearable
          disableFuture
          value={
            this.props.filter.modifiedStart
              ? moment(this.props.filter.modifiedStart)
              : null
          }
          onChange={this.props.handleDateChange("modifiedStart")}
        />
      </FormControl>
    );
    filterObj.authoredByMe = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.authoredByMe === true}
            onChange={this.props.handleCheckboxChange("authoredByMe")}
            value="onlyAuthoredByMe"
          />
        }
        label={t("filter_ki_authored_by_me")}
      />
    );
    filterObj.revisedByMe = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.revisedByMe === true}
            onChange={this.props.handleCheckboxChange("revisedByMe")}
            value="revisedByMe"
          />
        }
        label={t("filter_ki_revised_by_me")}
      />
    );
    filterObj.awaitingReview = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.awaitingReview === true}
            onChange={this.props.handleCheckboxChange("awaitingReview")}
            value="onlyAwaitingReview"
          />
        }
        label={t("filter_ki_only_awaiting_review")}
      />
    );
    filterObj.awaitingApprovalStage = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.awaitingApprovalStage === true}
            onChange={this.props.handleCheckboxChange("awaitingApprovalStage")}
            value="onlyAwaitingApprovalStage"
          />
        }
        label={t("filter_ki_only_awaiting_approval_stage")}
      />
    );
    filterObj.awaitingApproval = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.awaitingApproval === true}
            onChange={this.props.handleCheckboxChange("awaitingApproval")}
            value="onlyAwaitingApproval"
          />
        }
        label={t("filter_ki_only_awaiting_approval")}
      />
    );
    filterObj.awaitingPublish = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.awaitingPublish === true}
            onChange={this.props.handleCheckboxChange("awaitingPublish")}
            value="onlyAwaitingPublish"
          />
        }
        label={t("filter_ki_only_awaiting_publish")}
      />
    );
    filterObj.published = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.published === true}
            onChange={this.props.handleCheckboxChange("published")}
            value="published"
          />
        }
        label={t("filter_ki_published")}
      />
    );
    filterObj.beingEdited = (
      <FormControlLabel
        control={
          <Checkbox
            checked={this.props.filter.beingEdited === true}
            onChange={this.props.handleCheckboxChange("beingEdited")}
            value="beingEdited"
          />
        }
        label={t("filter_ki_being_edited")}
      />
    );
    filterObj.categories = (
      <FormControl style={this.state.formControl}>
        {this.props.isFilterSet("categories") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DocumentCategories
          defaultValue={this.props.filter.categories}
          onChange={this.onCategoryChange}
          disablePortal
        />
      </FormControl>
    );
    filterObj.showWithdrawn = (
      <FormControl component="fieldset">
        <FormLabel>{t("filter_ki_show_withdrawn_label")}</FormLabel>
        <RadioGroup
          row
          value={this.props.filter.showWithdrawn}
          onChange={this.props.handleTextFieldChange("showWithdrawn")}
        >
          <FormControlLabel
            value="HIDE"
            control={<Radio />}
            label={t("filter_ki_hide_withdrawn")}
          />
          <FormControlLabel
            value="SHOW"
            control={<Radio />}
            label={t("filter_ki_show_withdrawn")}
          />
          <FormControlLabel
            value="ONLY"
            control={<Radio />}
            label={t("filter_ki_only_show_withdrawn")}
          />
        </RadioGroup>
      </FormControl>
    );
    filterObj.documentTypes = (
      <FormControl className={classes.moreMarginFormControl}>
        {this.props.filter.documentTypes &&
          ((this.props.filter.documentTypes.length === 1 &&
            this.props.filter.documentTypes[0] !== -3) ||
            (this.props.filter.documentTypes.length > 1 &&
              this.props.filter.documentTypes.length <
                this.props.documentTypes.length)) && (
            <StyledBadge
              color="secondary"
              variant="dot"
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            />
          )}
        <DocumentType
          id="search-filters-document-type"
          search
          multiSelect={true}
          doctypes={this.props.documentTypes}
          docTypeSelected={this.props.handleSelectChange}
          documentType={
            this.props.filter.documentTypes
              ? this.props.filter.documentTypes
              : this.state.documentTypes
          }
        />
      </FormControl>
    );
    filterObj.createdBy = (
      <FormControl className={classes.userPickerFormControl}>
        <Trans i18nKey="global_create_past_tense" />
        <UserTeamPicker
          usersOnly={true}
          onTeamUsersUpdate={this.onCreatedByUpdate}
          onUsersUpdate={this.onCreatedByUpdate}
          userHeaderKey=""
          userTeamHeaderKey="create_message_users_team_header"
          asChips
          loadUsers={this.state.createdBy}
          hideNoUsersMessage={true}
        />
      </FormControl>
    );
    filterObj.modifiedBy = (
      <FormControl className={classes.userPickerFormControl}>
        <Trans i18nKey="global_modify_past_tense" />
        <UserTeamPicker
          usersOnly={true}
          onTeamUsersUpdate={this.onModifiedByUpdate}
          onUsersUpdate={this.onModifiedByUpdate}
          userHeaderKey=""
          userTeamHeaderKey="create_message_users_team_header"
          asChips
          loadUsers={this.state.modifiedBy}
          hideNoUsersMessage={true}
        />
      </FormControl>
    );

    const activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map(
              (filter, idx) =>
                filterObj.hasOwnProperty(filter) &&
                this.state.defaultFilters.indexOf(filter) < 0 && (
                  <Grid
                    item
                    xs={
                      filter === "showWithdrawn" ||
                      filter === "createdBy" ||
                      filter === "modifiedBy"
                        ? 12
                        : 6
                    }
                    sm={
                      filter === "showWithdrawn" ||
                      filter === "createdBy" ||
                      filter === "modifiedBy"
                        ? 6
                        : 3
                    }
                    lg={
                      filter === "showWithdrawn" ||
                      filter === "createdBy" ||
                      filter === "modifiedBy" 
                        ? 6 
                        : 2
                    }
                    classes={{ root: classes.gridItem }}
                  >
                    {filterObj[filter]}
                  </Grid>
                )
            )}
      </>
    );
    const inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(this.props.filter).map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 && (
                <Grid
                  item
                  xs={
                    filter === "showWithdrawn" ||
                    filter === "createdBy" ||
                    filter === "modifiedBy"
                      ? 12
                      : 6
                  }
                  sm={
                    filter === "showWithdrawn" ||
                    filter === "createdBy" ||
                    filter === "modifiedBy"
                      ? 6
                      : 3
                  }
                  lg={
                    filter === "showWithdrawn" ||
                    filter === "createdBy" ||
                    filter === "modifiedBy" 
                      ? 6 
                      : 2
                  }
                  classes={{ root: classes.gridItem }}
                  style={{ maxWidth: this.props.isMobile && "100%" }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
      </>
    );
    let defaultFilters = (
      <>
        {this.state.defaultFilters.map(
          (filter, idx) =>
            filterObj.hasOwnProperty(filter) &&
            filterObj[filter] && (
              <Grid
                item
                xs={
                  filter === "showWithdrawn" ||
                  filter === "createdBy" ||
                  filter === "modifiedBy"
                    ? 12
                    : 6
                }
                sm={
                  filter === "showWithdrawn" ||
                  filter === "createdBy" ||
                  filter === "modifiedBy"
                    ? 6
                    : 3
                }
                lg={
                  filter === "showWithdrawn" ||
                  filter === "createdBy" ||
                  filter === "modifiedBy" 
                    ? 6 
                    : 2
                }
                classes={{ root: classes.gridItem }}
                style={{ maxWidth: this.props.isMobile && "100%" }}
              >
                {filterObj[filter]}
              </Grid>
            )
        )}
      </>
    );

    return (
      <>
        {this.props.asPopper ? (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {this.props.filter !== null && (
              <div style={{ width: "100%" }}>
                {this.props.showReset && (
                  <Button
                    className={classes.resetButton}
                    onClick={this.props.resetToDefaultFilters}
                  >
                    <Trans i18nKey="filters_reset_to_default" />
                  </Button>
                )}
                <ExpansionPanel
                  expanded={expanded === "sort"}
                  onChange={this.props.handleExpansionPanelChange("sort")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_documents_sort_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.sort}
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "basic"}
                  onChange={this.props.handleExpansionPanelChange("basic")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_basic" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_ki_basic_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {filterObj.showWithdrawn}
                      <FormControl
                        component="fieldset"
                        style={this.state.formControl}
                      >
                        <FormLabel component="legend">
                          <Trans i18nKey="filter_ki_only_show_content_that" />
                        </FormLabel>
                        <FormGroup row>
                          {filterObj.authoredByMe}
                          {filterObj.revisedByMe}
                        </FormGroup>
                        <FormGroup row>
                          {filterObj.awaitingReview}
                          {filterObj.awaitingApprovalStage}
                          {filterObj.awaitingApproval}
                          {filterObj.awaitingPublish}
                          {filterObj.published}
                          {filterObj.beingEdited}
                        </FormGroup>
                        <FormGroup>{filterObj.documentTypes}</FormGroup>
                        <FormGroup>{filterObj.categories}</FormGroup>
                      </FormControl>
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "dates"}
                  onChange={this.props.handleExpansionPanelChange("dates")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort_dates" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_ki_dates_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div className={classes.datesContainer}>
                      <FormGroup row>
                        {filterObj.createdStart}
                        {filterObj.createdEnd}
                      </FormGroup>
                      <FormGroup row>
                        {filterObj.modifiedStart}
                        {filterObj.modifiedEnd}
                      </FormGroup>
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "sections"}
                  onChange={this.props.handleExpansionPanelChange("sections")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_section_plural" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_documents_sections_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.taxonomy}
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "users"}
                  onChange={this.props.handleExpansionPanelChange("users")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_user_plural" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_content_users_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div className={classes.userPickerWrapper}>
                      {filterObj.createdBy}
                    </div>
                    <div className={classes.userPickerWrapper}>
                      {filterObj.modifiedBy}
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
            )}
          </MuiPickersUtilsProvider>
        ) : (
          <div>
            <ListItem
              button
              onClick={(event) => event && event.stopPropagation()}
              className={classes.listItem}
              style={{
                paddingLeft: this.props.preText ? 0 : 10,
                borderRight: this.props.selected
                  ? `2px solid ${this.props.theme.palette.primary.main}`
                  : "",
              }}
              ContainerComponent="div"
              disableGutters={true}
              dense={true}
              selected={false}
            >
              {this.props.preText}
              <ListItemText
                primary={
                  <>
                    <div className={classes.filterWrapper}>
                      <span>
                        <IconButton
                          onClick={this.props.resetToDefaultFilters}
                          size="large"
                          color={
                            this.props.showReset === true
                              ? "secondary"
                              : "default"
                          }
                          disabled={this.props.showReset === false}
                        >
                          <Icon
                            path={
                              this.props.showReset === true
                                ? mdiFilterVariantRemove
                                : mdiFilterVariant
                            }
                            size={1.5}
                          />
                        </IconButton>
                      </span>
                      <div className={classes.filterWrapper}>
                        <Collapse
                          in={this.state.menuCollapseOpened}
                          timeout="auto"
                          unmountOnExit
                          style={{ width: "100%" }}
                        >
                          <Grid
                            container
                            classes={{ root: classes.gridContainer }}
                            style={{
                              flexDirection: this.props.isMobile && "column",
                            }}
                          >
                            {defaultFilters}
                            {activeFilters}
                            <Collapse
                              in={this.state.opened}
                              timeout="auto"
                              unmountOnExit
                            >
                              {/* <Table size="small">
                              <> */}
                              <Grid
                                container
                                classes={{ root: classes.gridContainer }}
                                style={{
                                  flexDirection:
                                    this.props.isMobile && "column",
                                }}
                              >
                                {inActiveFilters}
                              </Grid>
                              {/* </>
                            </Table> */}
                            </Collapse>
                          </Grid>
                        </Collapse>
                      </div>
                    </div>
                  </>
                }
                secondary={""}
              />
              {!this.props.hideExpand && (
                <IconButton onClick={this.toggleExpand}>
                  {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </ListItem>
          </div>
        )}
      </>
    );
  }
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.isMobile && this.props.menuDialog
      ? this.setState((prev) => ({
          menuCollapseOpened: !prev.menuCollapseOpened,
        }))
      : this.setState((prev) => ({ opened: !prev.opened }));
  };
  onCreatedByUpdate = (newUsers) => {
    // if (!areObjectsEqual(this.props.filter.createdBy, newUsers.map((u) => u.userId))) {
    let event = {};
    event.target = {};
    event.target.name = "createdBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
    // }
  };
  onModifiedByUpdate = (newUsers) => {
    let event = {};
    event.target = {};
    event.target.name = "modifiedBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
  };
  onCategoryChange = (cat) => {
    this.props.handleChange({
      target: { name: "categories", value: cat.map((c) => c.id) },
    });
  };
}
const mapStateToProps = (state) => ({
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  documentTypes: state.prefs.documentTypes,
  isMobile: state.screen.isMobile,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(CoreFilter(FilterKnowledgeItems))));
